import captcha from '../../../api/captcha'
import user from '../../../api/user'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      form: {
        password: '',
        cpassword: ''
      },
      code: {},
      rules: {},
      isChecked: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherInfo: 'getPublisherInfo',
      publisherId: 'getPublisherId',
      domain: 'getDomain'
    })
  },
  mounted() {
    this.getCaptcha()
    this.getRules()
    document.onkeyup = e => {
      // 兼容FF和IE和Opera
      var event = e || window.event
      var key = event.which || event.keyCode || event.charCode
      if (key == 13 && this.$route.path === '/access/register') {
        this.submit()
      }
    }
  },
  methods: {
    async submit() {
      const flag = this.$refs['register-form'].validate()
      if (flag) {
        const data = Object.assign(
          { publisherId: this.publisherId, cid: this.code.cid },
          this.form
        )
        try {
          await user.register(data)
          this.$router.push(
            `/access/result?email=${this.form.email}&type=register`
          )
        } catch (e) {
          this.getCaptcha()
          return
        }
      }
    },
    async getCaptcha() {
      this.code = await captcha.get()
    },
    getRules() {
      const that = this
      this.rules = {
        email: [
          {
            required: true,
            message: 'Username' + this.LANGUAGE[this.language].noEmpty + '.'
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].inputCorrectEmail + '.'
          }
        ],
        password: [
          {
            required: true,
            message: 'Password' + this.LANGUAGE[this.language].noEmpty + '.'
          },
          {
            min: 6,
            message: `Password should be more than 6 characters.`
          },
          {
            max: 20,
            message: `Password length must not be more than 20 characters`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols, but not spaces.`
          }
        ],
        cpassword: [
          {
            required: true,
            message:
              'Confirm Password' + this.LANGUAGE[this.language].noEmpty + '.'
          },
          {
            min: 6,
            message: `Confirm Password should be more than 6 characters.`
          },
          {
            max: 20,
            message: `Confirm Password length must not be more than 20 characters`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols, but not spaces.`
          },
          {
            fun() {
              return that.form.password === that.form.cpassword
            },
            message: `Confirm Password should be the same as above password.`
          }
        ],
        code: [
          {
            required: true,
            message:
              'Verification Code' + this.LANGUAGE[this.language].noEmpty + '.'
          }
        ]
      }
    }
  }
}
